import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=27d6c3fa&scoped=true&"
import script from "./categoryManage.vue?vue&type=script&lang=js&"
export * from "./categoryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6c3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d6c3fa')) {
      api.createRecord('27d6c3fa', component.options)
    } else {
      api.reload('27d6c3fa', component.options)
    }
    module.hot.accept("./categoryManage.vue?vue&type=template&id=27d6c3fa&scoped=true&", function () {
      api.rerender('27d6c3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/categoryManage.vue"
export default component.exports